import { WebScrapingService } from 'api/generated';
import { QueryError, formatErrorMessage } from 'features/shared/model';
import { UseMutationOptions, useMutation } from 'react-query';
import { toast } from 'react-toastify';

export type EmployeeDrivingLicenceCheckInput = {
  userId: number;
  driverLicenceNum: string;
  nationalInsuranceNum: string;
  postCode: string;
};

export const useEmployeeDrivingLicenceCheckMutation = (
  options?: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof WebScrapingService.getWebScrapingGetDriverInfo>>,
      unknown,
      EmployeeDrivingLicenceCheckInput,
      unknown
    >,
    'mutationFn'
  >
) =>
  useMutation(
    ({ userId, driverLicenceNum, nationalInsuranceNum, postCode }) =>
      WebScrapingService.getWebScrapingGetDriverInfo(userId, driverLicenceNum, nationalInsuranceNum, postCode),
    {
      ...options,
      onSuccess: () => {
        toast.success('Successfully created!');
      },
      onError: (error: QueryError) => {
        const message = formatErrorMessage(error);
        toast.error(message);
        console.error(message);
      }
    }
  );
